import { ReactElement, useEffect } from "react";
import { Navigate, Outlet, useNavigate, useParams } from "react-router-dom";
import { routes } from "routes";
import { ReplaceWords } from "utils/ReplaceWords";

import { useSelector } from "react-redux";
import { RootStateType } from "storeRedux/store";
import { Logout } from "./logout/logout";
import { Login } from "./login/login";
// import { Outlet } from "react-router-dom";


type pagesType = "login" | "register" | "logout"


export const Auth = (): ReactElement => {

    const pages: pagesType[] = ["login", "register", "logout"];
    const navigate = useNavigate();
    const auth = useSelector((state: RootStateType) => state.auth);
    const { user } = auth;
    const { pro } = useParams() as { pro: pagesType };

    const pageContent: { [ket in pagesType]?: ReactElement } = {
        "login": user?.id ? <Navigate to={routes.dashboard} /> : <Login />,
        // "register":user?.id?<Navigate to={routes.dashboard} />:<Register/>,
        "logout": <Logout />
    }







    useEffect(() => {
        if (!pages.includes(pro) && !user?.id) {
            navigate(ReplaceWords(routes.authProcess, { pro: "login" }))
        }
    }, [pro]);


    return pageContent[pro] ? <div className=" w-full h-full flex justify-center items-center " >
        <div className=" w-full px-2 sm:p-0 sm:w-[350px]  " >
            {pageContent[pro] || <></>}
        </div>
    </div> : <Outlet />

} 